import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';

export default function MusicAlbumAddPopup2({
  onClose,
  onDone,
} : {
  onClose: () => void,
  onDone: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);
  const [agreement3, setAgreement3] = React.useState(false);
  const [agreement4, setAgreement4] = React.useState(false);
  const disabled = !agreement1
    || !agreement2
    || !agreement3
    || !agreement4;

  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <div className="list__body album_delivery">
        <ul className="notes_box">
          <span className="notes red">下記の注意事項に同意してください。</span>
        </ul>
        <dl>
          <dd>
            <CustomCheckbox checked={agreement1} setChecked={(checked) => setAgreement1(checked)}>
              お申し込みから約50日以内に配信されます。配信開始日は設定できません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement2} setChecked={(checked) => setAgreement2(checked)}>
              配信先のアーティスト写真の設定はできません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement3} setChecked={(checked) => setAgreement3(checked)}>
              カバー曲や、他者の音源を加工した曲、AI生成音楽は配信できません。ループ音源を使用している場合も審査に通らず配信できない場合があります。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement4} setChecked={(checked) => setAgreement4(checked)}>
              審査の結果、配信できない場合があります。審査はFrekul内で完結せず基準も随時変化するため、理由を個別にお伝えすることができません。
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a href="https://help.frekul.com/1444/" target="_blank">具体的に知りたい方向けヘルプ</a>
            </CustomCheckbox>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onClose()}>キャンセル</CustomButton>
            <CustomButton type="default-split" disabled={disabled} onClick={() => onDone()}>同意して作成</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
